import React from 'react';
import { XIcon } from 'lucide-react';
export function PainSection() {
  return <section id="pain-section" className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#0f172a',
    borderColor: '#334155'
  }} data-id="element-216">
      <div className="max-w-3xl mx-auto" data-id="element-217">
        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-8" style={{
        color: '#f1f5f9'
      }} data-id="element-218">
          Puede que estés pensando ahora mismo:
        </h2>

        <div className="space-y-4 mb-8 rounded-md p-6 border" style={{
        backgroundColor: '#1e293b',
        borderColor: '#334155'
      }} data-id="element-219">
          <p className="text-lg italic" style={{
          color: '#94a3b8'
        }} data-id="element-220">
            "Suena bien... pero no sé nada de esto."
          </p>
          <p className="text-lg italic" style={{
          color: '#94a3b8'
        }} data-id="element-221">
            "Nunca he ganado dinero por internet en mi vida."
          </p>
          <p className="text-lg italic" style={{
          color: '#94a3b8'
        }} data-id="element-222">
            "Seguro hay algo complicado que no me están diciendo."
          </p>
        </div>

        <p className="text-lg mb-8" style={{
        color: '#94a3b8'
      }} data-id="element-223">
          Esos pensamientos son exactamente los que tenía cada persona que hoy
          gana{' '}
          <strong style={{
          color: '#f59e0b'
        }} data-id="element-224">
            2 a 6 millones al mes
          </strong>{' '}
          con este sistema — antes de empezar.
        </p>

        <p className="text-lg mb-8" style={{
        color: '#f1f5f9'
      }} data-id="element-225">
          El{' '}
          <strong style={{
          color: '#f59e0b'
        }} data-id="element-226">
            Sistema LPM™
          </strong>{' '}
          fue creado específicamente para personas que empiezan desde cero
          absoluto.
        </p>

        <p className="text-lg font-bold mb-6" style={{
        color: '#f1f5f9'
      }} data-id="element-227">
          Personas que:
        </p>

        <div className="space-y-3 mb-12" data-id="element-228">
          <div className="flex items-start gap-3" data-id="element-229">
            <XIcon className="h-5 w-5 mt-1 flex-shrink-0" style={{
            color: '#64748b'
          }} aria-hidden="true" data-id="element-230" />
            <p className="text-lg" style={{
            color: '#94a3b8'
          }} data-id="element-231">
              Nunca han creado una página web
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-232">
            <XIcon className="h-5 w-5 mt-1 flex-shrink-0" style={{
            color: '#64748b'
          }} aria-hidden="true" data-id="element-233" />
            <p className="text-lg" style={{
            color: '#94a3b8'
          }} data-id="element-234">
              No saben qué es el "marketing digital"
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-235">
            <XIcon className="h-5 w-5 mt-1 flex-shrink-0" style={{
            color: '#64748b'
          }} aria-hidden="true" data-id="element-236" />
            <p className="text-lg" style={{
            color: '#94a3b8'
          }} data-id="element-237">
              Solo usan su computador para ver videos
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-238">
            <XIcon className="h-5 w-5 mt-1 flex-shrink-0" style={{
            color: '#64748b'
          }} aria-hidden="true" data-id="element-239" />
            <p className="text-lg" style={{
            color: '#94a3b8'
          }} data-id="element-240">
              Nunca han ganado un dólar por internet
            </p>
          </div>
        </div>

        <h3 className="text-2xl font-bold mb-6" style={{
        color: '#f1f5f9'
      }} data-id="element-241">
          Si puedes hacer esto — Puedes usar el sistema:
        </h3>

        <div className="overflow-x-auto mb-8" data-id="element-242">
          <table className="w-full border-collapse rounded-md overflow-hidden" data-id="element-243">
            <thead data-id="element-244">
              <tr style={{
              backgroundColor: '#f59e0b'
            }} data-id="element-245">
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#0f172a'
              }} data-id="element-246">
                  Acción Simple
                </th>
                <th className="text-center p-4 text-sm font-bold" style={{
                color: '#0f172a'
              }} data-id="element-247">
                  ¿Puedes?
                </th>
              </tr>
            </thead>
            <tbody data-id="element-248">
              <tr style={{
              backgroundColor: '#1e293b',
              borderColor: '#334155'
            }} className="border-b" data-id="element-249">
                <td className="p-4" style={{
                color: '#f1f5f9'
              }} data-id="element-250">
                  Enviar un mensaje de texto
                </td>
                <td className="p-4 text-center text-xl" data-id="element-251">✅</td>
              </tr>
              <tr style={{
              backgroundColor: '#0f172a',
              borderColor: '#334155'
            }} className="border-b" data-id="element-252">
                <td className="p-4" style={{
                color: '#f1f5f9'
              }} data-id="element-253">
                  Buscar algo en Google
                </td>
                <td className="p-4 text-center text-xl" data-id="element-254">✅</td>
              </tr>
              <tr style={{
              backgroundColor: '#1e293b',
              borderColor: '#334155'
            }} className="border-b" data-id="element-255">
                <td className="p-4" style={{
                color: '#f1f5f9'
              }} data-id="element-256">
                  Seguir una receta paso a paso
                </td>
                <td className="p-4 text-center text-xl" data-id="element-257">✅</td>
              </tr>
              <tr style={{
              backgroundColor: '#0f172a',
              borderColor: '#334155'
            }} className="border-b" data-id="element-258">
                <td className="p-4" style={{
                color: '#f1f5f9'
              }} data-id="element-259">
                  Copiar y pegar texto
                </td>
                <td className="p-4 text-center text-xl" data-id="element-260">✅</td>
              </tr>
              <tr style={{
              backgroundColor: '#1e293b'
            }} data-id="element-261">
                <td className="p-4" style={{
                color: '#f1f5f9'
              }} data-id="element-262">
                  Descargar un PDF
                </td>
                <td className="p-4 text-center text-xl" data-id="element-263">✅</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-lg font-bold text-center" style={{
        color: '#f59e0b'
      }} data-id="element-264">
          Si marcaste ✅ en cualquiera de estas — estás 100% listo.
        </p>
      </div>
    </section>;
}